// 主题色配置，统一管理全局颜色（单一色值）
const THEME_YELLOW = '#d6e100';

const theme = {
  PRIMARY_COLOR: THEME_YELLOW,
  PRIMARY_TEXT_COLOR: '#222',
  CANCEL_BG: '#fff',
  CANCEL_TEXT: '#666',
  CANCEL_BORDER: THEME_YELLOW,
  CANCEL_HOVER_BG: '#f7fbe2',
  CANCEL_HOVER_BORDER: THEME_YELLOW,
  BUTTON_BG: THEME_YELLOW,
};

export default theme;
